module.exports = __webpack_public_path__ + "img/manage-booking-en.19d4bbf0.png";